import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import { TabsModule } from 'ng2-bootstrap/components/tabs';

import { SharedModule } from './../shared/shared.module';
import { HomeAccount } from './home-account/home-account.component';
import { GenerateInvoice } from './generate-invoice/generate-invoice.component';
import { PendingInvoice } from './pending-invoice/pending-invoice.component';
import { ManualInvoice } from './manual-invoice/manual-invoice.component';
import { AccountRoutingModule } from './account-routing';
import { ManualPaymentInvoice } from './manualInvoice-payment/manualInvoice-payment.component';
@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		AccountRoutingModule,
		SlimScrollModule,
		TabsModule,

	],
	declarations: [HomeAccount, GenerateInvoice, PendingInvoice, ManualInvoice, ManualPaymentInvoice]
})
export class AccountModule { }



// WEBPACK FOOTER //
// ./src/app/account/account.module.ts